// Copyright (c) 2016 Deere & Company

import Product from '@deere/cps-it.warranty-model-factory/lib/product';
import actions from '../../action-list';
import {getDefaultState} from '../state';

const resetProductDetails = () => getDefaultState().product;

const setProductDetails = (state, action) =>
    Product.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().product, action) => {

    const actionTypes = {
        [actions.RESET_CLAIM_SPA]: resetProductDetails,
        [actions.RESET_CLAIM_SPA_PRODUCT_DETAILS]: resetProductDetails,
        [actions.SET_CLAIM_SPA_PRODUCT_DETAILS]: setProductDetails
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/spa/reducers/product-details.js